export default __webpack_public_path__ + "static/media/auth-banner.27c12ada.png";